import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import z from "zod";
import { QueuePage } from "@/features/admin/queue/queue-page";
import { ReviewStateArray, ReviewTypeArray } from "@/constants";
import { adminReviewRequestsInfiniteQueryOptions } from "@/lib/client/review";

export const Route = createFileRoute("/admin/queue")({
  staticData: {
    viewPadding: 0,
    title: "复盘队列",
  },
  validateSearch: z.object({
    filter: z.enum(ReviewStateArray).optional().catch("queued").default("queued"),
    type: z.enum(ReviewTypeArray).optional().catch("review").default("review"),
  }),
  staleTime: Infinity,
  gcTime: Infinity,
  preload: false,
  loaderDeps: (opts) => opts.search,
  component: RouteComponent,
  async loader({ context, deps }) {
    await context.queryClient.ensureInfiniteQueryData(
      adminReviewRequestsInfiniteQueryOptions(deps.filter, deps.type),
    );
  },
});

function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const routerState = useRouterState();
  const path = routerState.location.pathname;
  const isIndexRoute = path === "/admin/queue" || path === "/admin/queue/";
  const isDetailRoute = !isIndexRoute && path.startsWith("/admin/queue/");

  return (
    <QueuePage
      search={search}
      isIndexRoute={isIndexRoute}
      isDetailRoute={isDetailRoute}
      onFilterChanged={(filter) => navigate({ search: { ...search, filter }, replace: true })}
      onTypeChanged={(type) => navigate({ search: { ...search, type }, replace: true })}
      onReturnToQueue={() => navigate({ to: "/admin/queue", search, replace: true })}
    >
      <Outlet />
    </QueuePage>
  );
}
